import React from "react";

// Creating the context object and passing the default values.
const KycApplicationContext = React.createContext({
  currentHolder: {},
  setCurrentHolder: () => {},
  currentWorkflow: {},
  setCurrentWorkflow: () => {},
  currentWidget: {},
  setCurrentWidget: () => {},
  mode: "",
  setMode: () => {},
  disableForm: "",
  setDisableForm: () => {},
  widgetShortNameToShow:"",
  setWidgetShortNameToShow: ()=>{},
  moveToHolder: "",
  setMoveToHolder: ()=>{},
});

export default KycApplicationContext;
